import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=11dafb36&"
import script from "./Datenschutz.vue?vue&type=script&lang=ts&"
export * from "./Datenschutz.vue?vue&type=script&lang=ts&"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports